export const ErrorOccured = () => {
	return (
		<p className='fw-normal m-0'>
			Error Occured! Please check your network or contact system administrator.
		</p>
	);
};
